// Copyright (c) 2016 Deere & Company

import StatusChangeRequest from '../../product/status-change-request/state-connector';

export default {
    component: StatusChangeRequest,
    name: 'STATUS_CHANGE_REQUEST',
    path: 'status-change-request/:pin'
};



// WEBPACK FOOTER //
// ./src/routes/products/status-change-request-route.js